module.exports = __webpack_public_path__ + "static/img/whats-included-latest.e4abd35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whats-included-latest.png
// module id = 2R0c
// module chunks = 1